/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ExperienceLevel,
	ExperienceLevelFromJSON,
	ExperienceLevelFromJSONTyped,
	ExperienceLevelToJSON,
} from "./ExperienceLevel";

/**
 *
 * @export
 * @interface PoliJobsContactDetailsDTO
 */
export interface PoliJobsContactDetailsDTO {
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsDTO
	 */
	phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsDTO
	 */
	personalEmail?: string | null;
	/**
	 *
	 * @type {ExperienceLevel}
	 * @memberof PoliJobsContactDetailsDTO
	 */
	experienceLevel?: ExperienceLevel;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsDTO
	 */
	currentCompany?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsContactDetailsDTO
	 */
	currentPosition?: string | null;
}

export function PoliJobsContactDetailsDTOFromJSON(
	json: any
): PoliJobsContactDetailsDTO {
	return PoliJobsContactDetailsDTOFromJSONTyped(json, false);
}

export function PoliJobsContactDetailsDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsContactDetailsDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
		personalEmail: !exists(json, "personalEmail")
			? undefined
			: json["personalEmail"],
		experienceLevel: !exists(json, "experienceLevel")
			? undefined
			: ExperienceLevelFromJSON(json["experienceLevel"]),
		currentCompany: !exists(json, "currentCompany")
			? undefined
			: json["currentCompany"],
		currentPosition: !exists(json, "currentPosition")
			? undefined
			: json["currentPosition"],
	};
}

export function PoliJobsContactDetailsDTOToJSON(
	value?: PoliJobsContactDetailsDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		phone: value.phone,
		personalEmail: value.personalEmail,
		experienceLevel: ExperienceLevelToJSON(value.experienceLevel),
		currentCompany: value.currentCompany,
		currentPosition: value.currentPosition,
	};
}
